import { brandCategoryForm } from '@/pages/menu-managements/categories/service';
import { FormError, validBlank, validMaxStr } from '@/validate';

export type CategoryFormError = {
  titleJa: FormError;
  memo: FormError;
};

export const validateTitleJa = (
  titleJa: string,
  error: CategoryFormError
): CategoryFormError => {
  error.titleJa.isTouched = true;
  const label = brandCategoryForm.titleJa.label;
  const isMax = validMaxStr.check(titleJa, 80);
  const isBlank = validBlank.check(titleJa);
  if (isBlank) error.titleJa.message = validBlank.message(label);
  if (isMax) error.titleJa.message = validMaxStr.message(label, 80);
  error.titleJa.isError = isBlank || isMax;
  return error;
};

export const validateMemo = (
  memo: string,
  error: CategoryFormError
): CategoryFormError => {
  error.titleJa.isTouched = true;
  const label = brandCategoryForm.memo.label;
  const isMax = validMaxStr.check(memo, 2000);
  if (isMax) error.memo.message = validMaxStr.message(label, 2000);
  error.memo.isError = isMax;
  return error;
};
